import React from 'react'
import { Route } from 'react-router-dom'
import { Plan, PlanEditPopup } from '../../../../views/Dashboard/Plan'

// eslint-disable-next-line react/display-name
export default ({ match }) => (
  <>
    {/* Company */}
    <Route path={`${match.path}/edit`} component={PlanEditPopup} />

    {/* Redirect if exact matched */}
    <Route path={match.path} component={Plan} />
  </>
)
